import { useState, useEffect } from 'react';
import { API, Endpoints } from '@brg/api';

// Кеш для загруженных карточек
const cardsCache = new Map<string, { card: any; loading: boolean; error: boolean }>();

/**
 * Кешированный хук для получения карточки
 */
export const useGetCardCached = (cardId: string, disabled?: boolean) => {
  const [card, setCard] = useState<any>(() => {
    if (!cardId || disabled) return undefined;
    const cached = cardsCache.get(cardId);
    return cached?.card;
  });
  const [isLoading, setIsLoading] = useState(() => {
    if (!cardId || disabled) return false;
    const cached = cardsCache.get(cardId);
    return cached?.loading || false;
  });
  const [error, setError] = useState(() => {
    if (!cardId || disabled) return false;
    const cached = cardsCache.get(cardId);
    return cached?.error || false;
  });

  useEffect(() => {
    if (disabled || !cardId) {
      return;
    }

    // Проверяем кеш
    const cached = cardsCache.get(cardId);
    if (cached) {
      setCard(cached.card);
      setIsLoading(cached.loading);
      setError(cached.error);
      return;
    }

    // Если данных нет в кеше, загружаем
    setIsLoading(true);
    const cacheEntry = { card: undefined, loading: true, error: false };
    cardsCache.set(cardId, cacheEntry);

    API.request()
      .endpoint(Endpoints.cardsMnePw)
      .url('/api/Card/GetCard')
      .addQuery('id', cardId)
      .get()
      .send()
      .then((r) => r.json())
      .then((r) => {
        setCard(r);
        setIsLoading(false);
        cardsCache.set(cardId, { card: r, loading: false, error: false });
      })
      .catch((e) => {
        setIsLoading(false);
        setError(true);
        cardsCache.set(cardId, { card: undefined, loading: false, error: true });
      });
  }, [cardId, disabled]);

  return { card, isLoading, error };
};
import { useState, useEffect } from 'react';
import { API, Endpoints } from '@brg/api';

// Кеш для загруженных карточек
const cardsCache = new Map<string, { card: any; loading: boolean; error: boolean }>();

/**
 * Кешированный хук для получения карточки
 */
export const useGetCardCached = (cardId: string, disabled?: boolean) => {
  const [card, setCard] = useState<any>(() => {
    if (!cardId || disabled) return undefined;
    const cached = cardsCache.get(cardId);
    return cached?.card;
  });
  const [isLoading, setIsLoading] = useState(() => {
    if (!cardId || disabled) return false;
    const cached = cardsCache.get(cardId);
    return cached?.loading || false;
  });
  const [error, setError] = useState(() => {
    if (!cardId || disabled) return false;
    const cached = cardsCache.get(cardId);
    return cached?.error || false;
  });

  useEffect(() => {
    if (disabled || !cardId) {
      return;
    }

    // Проверяем кеш
    const cached = cardsCache.get(cardId);
    if (cached) {
      setCard(cached.card);
      setIsLoading(cached.loading);
      setError(cached.error);
      return;
    }

    // Если данных нет в кеше, загружаем
    setIsLoading(true);
    const cacheEntry = { card: undefined, loading: true, error: false };
    cardsCache.set(cardId, cacheEntry);

    API.request()
      .endpoint(Endpoints.cardsMnePw)
      .url('/api/Card/GetCard')
      .addQuery('id', cardId)
      .get()
      .send()
      .then((r) => r.json())
      .then((r) => {
        setCard(r);
        setIsLoading(false);
        cardsCache.set(cardId, { card: r, loading: false, error: false });
      })
      .catch((e) => {
        setIsLoading(false);
        setError(true);
        cardsCache.set(cardId, { card: undefined, loading: false, error: true });
      });
  }, [cardId, disabled]);

  return { card, isLoading, error };
};
